export const _ = (message) => {
  if (window.messages && window.messages[message]) {
    return window.messages[message][0]
  }

  return message
}
